import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getFertilizers.success: {
            return action.payload;
        }


        case constants.getFertilizers.try:
        case constants.getFertilizers.error: {
            return {};
        }

        default:
            return state;
    }
}